import styled, { css } from 'styled-components';

export const Header = styled.header`
    background-color: #1b1b1b;
`;

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    max-width: 144rem;

    padding: 2rem;
    margin: auto;
`;

export const Logo = styled.img`
    max-width: 12rem;
    margin-right: 2rem;

    @media (min-width: 768px) {
        max-width: 20rem;
    }
`;

export const NavigationContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const NavigationItems = styled.div`
    display: none;

    @media (min-width: 768px) {
        display: flex;
    }
`;

export const NavigationItem = styled.a<{ active? }>`
    display: flex;
    flex-direction: column;
    align-items: center;

    margin-right: 2rem;

    color: #999;
    font-size: 1.4rem;

    svg {
        margin-bottom: 0.3rem;
    }

    &:hover {
        color: #fff;
    }

    ${({ active }) =>
        active &&
        css`
            color: #fff;
        `}
`;
